// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Multicharts Layout Styles
 * CSS Grid layout for multicharts view with left sidebar toolbar
 * 
 * Layout Structure:
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │ Header (40px) - UnifiedHeader                                               │
 * ├──────────────────┬──────────────────────────────────────────────────────────┤
 * │                  │                                                          │
 * │ Drawing          │                                                          │
 * │ Toolbar          │         Charts Grid (MAXIMIZED AREA)                     │
 * │ (48px/280px)     │                                                          │
 * │                  │                                                          │
 * ├──────────────────┴──────────────────────────────────────────────────────────┤
 * │ Footer (32px) - MultiChartsFooter (auto-hide on mobile)                     │
 * └─────────────────────────────────────────────────────────────────────────────┘
 */

.uGMOoN4K9cKvAaBHYf0m {
  display: grid;
  grid-template-rows: 40px 1fr 32px;
  grid-template-columns: 1fr;
  grid-template-areas:
    "header"
    "charts"
    "footer";
  height: 100%;
  height: 100dvh;
  width: 100%;
  overflow: hidden;
  background: var(--vnsc-bg-primary, #131722);
  color: var(--vnsc-text-primary, #d1d4dc);
  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
}

/* Header - spans full width */
.C0buiSvEwKHlhirU_gNr {
  grid-area: header;
  z-index: 100;
  flex-shrink: 0;
}

.WkTc7VA7ItuB3zne23eB {
  cursor: pointer;
}

/* Toolbar - absolute overlay */
.GPpbNxgAfiPpFd4AcAEc {
  position: absolute;
  left: 0;
  top: 40px;
  bottom: 32px;
  width: 0px;
  z-index: 500;
  display: flex;
  flex-direction: column;
  overflow: visible;
  pointer-events: none;
}

/* Toolbar locked / docked mode (TASK-03) */
.TF7yQ34YrHNDvxbHBAFn .GPpbNxgAfiPpFd4AcAEc {
  width: 44px;
  pointer-events: auto;
}

.TF7yQ34YrHNDvxbHBAFn .tqrmx8MfjjB6Y6TJ8sYW {
  margin-left: 44px;
}

/* Bottom panel (Paper Trading / Strategy Tester / Pine Editor) is a grid
   sibling of .charts (implicit row above the footer), so it needs the same
   docked-rail clearance — otherwise the 44px rail overlaps its left edge. */
.TF7yQ34YrHNDvxbHBAFn [data-vnsc-bottom-panel="host"] {
  margin-left: 44px;
}

/* Charts area - maximized */
.tqrmx8MfjjB6Y6TJ8sYW {
  grid-area: charts;
  z-index: 10;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

/* S1 (F8 full-height, mirror single): body-row chứa mainCol (charts +
   panel) và dock. Overlay neo theo body (full content height như toolbar);
   pinned in-flow đẩy cả col (grid + panel co như singlechart). */
.CKcUXpPOtLqbuZPE0I_K {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  min-width: 0;
  position: relative;
  z-index: 10;
}

.laVS05mDRGY_aUq2tlef {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

/* .charts là con flex của mainCol (giữ position/overflow cho replay overlay). */
.CKcUXpPOtLqbuZPE0I_K .tqrmx8MfjjB6Y6TJ8sYW {
  flex: 1;
  min-height: 0;
}

/* Footer - spans full width */
.XSgINE28Vb1D87LjgeTV {
  grid-area: footer;
  z-index: 100;
  flex-shrink: 0;
  transition: height 0.2s ease, opacity 0.2s ease, padding 0.2s ease;
}

/* Footer hidden state (auto-hide on mobile or chart focused) */
.XSgINE28Vb1D87LjgeTV.VckaXpRpayS5qjEk2rZm {
  height: 0;
  padding: 0 16px;
  opacity: 0;
  pointer-events: none;
  border-top: none;
}

/* ============================================
   Responsive Breakpoints
   ============================================ */

/* Desktop & Tablet toolbar visibility */
@media (min-width: 769px) {
  .GPpbNxgAfiPpFd4AcAEc {
    display: flex;
  }
}

/* Mobile (<768px) - Toolbar hidden, shown via FAB */
@media (max-width: 768px) {
  .uGMOoN4K9cKvAaBHYf0m {
    grid-template-columns: 1fr;
    grid-template-rows: 40px 1fr 0px;
    grid-template-areas:
      "header"
      "charts"
      "footer";
  }
  
  .GPpbNxgAfiPpFd4AcAEc {
    display: none;
  }
  
  .GPpbNxgAfiPpFd4AcAEc.TakSWYyihw5fMquxNm3T {
    display: flex;
    position: fixed;
    top: 40px; /* Below header */
    left: 0;
    bottom: 32px; /* Above footer */
    width: 280px;
    max-width: 85vw;
    height: auto;
    max-height: calc(100vh - 72px);
    z-index: 1000;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
    border-right: 1px solid var(--vnsc-border, #2a2e39);
    min-width: 280px;
    max-width: 280px;
    width: 280px;
  }
  
  .XSgINE28Vb1D87LjgeTV {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0px;
    min-height: 0px;
    padding: 0;
    border-top: none;
    overflow: visible;
    pointer-events: none;
    background: transparent;
    z-index: 100;
  }
}

/* ============================================
   Toolbar Internal Layout
   ============================================ */

.GPpbNxgAfiPpFd4AcAEc .unifiedDrawingToolbar {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Ensure toolbar content scrolls when expanded */
.GPpbNxgAfiPpFd4AcAEc.K1AtK5MPnEQ9sCxepkqn .unifiedDrawingToolbar {
  overflow-y: auto;
}

/* Collapsed toolbar - only show icons */
.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarContent {
  display: none;
}

.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarHeader {
  padding: 8px;
  justify-content: center;
}

.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarHeader .toolbarTitle,
.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarHeader .lockToggle,
.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarHeader .collapseToggle {
  display: none;
}

.GPpbNxgAfiPpFd4AcAEc.HPgd5MKkETlVS6EC5mnI .toolbarHeader .expandToggle {
  display: flex;
}

/* ============================================
   Charts Grid Container
   ============================================ */

.plua5kAY_Zfbv3qCsDSc {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

/* Grid container for chart slots */
.clspduxZXiEWMo8tjf0M {
  flex: 1;
  display: grid;
  gap: 8px;
  padding: 8px;
  min-height: 0;
  overflow: auto;
}

/* Grid layout variations based on chart count */
.clspduxZXiEWMo8tjf0M[data-layout="1x1"] { grid-template-columns: 1fr; grid-template-rows: 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="1x2"] { grid-template-columns: 1fr 1fr; grid-template-rows: 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="2x1"] { grid-template-columns: 1fr; grid-template-rows: 1fr 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="2x2"] { grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="1x4"] { grid-template-columns: repeat(4, 1fr); grid-template-rows: 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="4x1"] { grid-template-columns: 1fr; grid-template-rows: repeat(4, 1fr); }
.clspduxZXiEWMo8tjf0M[data-layout="2x4"] { grid-template-columns: repeat(4, 1fr); grid-template-rows: 1fr 1fr; }
.clspduxZXiEWMo8tjf0M[data-layout="3x3"] { grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(3, 1fr); }

/* Chart slot */
.POZJ4T2O94dSYG6dqBdd {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid var(--vnsc-border, #2a2e39);
  border-radius: 8px;
  overflow: hidden;
  background: var(--vnsc-bg-primary, #131722);
  position: relative;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.POZJ4T2O94dSYG6dqBdd:hover {
  border-color: var(--vnsc-border-hover, #3a3e49);
}

.POZJ4T2O94dSYG6dqBdd.AckVU2_HXzkjZE3I5VqY {
  border: 1px solid var(--vnsc-primary, #2962ff);
}

.POZJ4T2O94dSYG6dqBdd.igM6sFFtNiCifeaRtd3m {
  border: 2px dashed var(--vnsc-border, #2a2e39);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--vnsc-bg-secondary, #1e222d);
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.POZJ4T2O94dSYG6dqBdd.igM6sFFtNiCifeaRtd3m:hover {
  background: var(--vnsc-bg-tertiary, #262b36);
  border-color: var(--vnsc-primary, #2962ff);
}

.POZJ4T2O94dSYG6dqBdd.igM6sFFtNiCifeaRtd3m:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--vnsc-primary, #2962ff);
}

.POZJ4T2O94dSYG6dqBdd.igM6sFFtNiCifeaRtd3m span {
  color: var(--vnsc-text-muted, #787b86);
  font-size: 14px;
  pointer-events: none;
}

/* Slot header with symbol badge */
.YEH90U9ZziuWtWaAVN3s {
  position: absolute;
  top: 4px;
  left: 8px;
  right: 8px;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  pointer-events: none;
}

.YEH90U9ZziuWtWaAVN3s > * {
  pointer-events: auto;
}

.dbJ6pgUgimItoimqcFZo {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.aDmMClrETuqYtL4RTtQQ {
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.MtJjnDUkDN0kEmkyFPDP { background-color: #e74c3c; }
.Pbisyyb7MrMe40NuNA6A { background-color: #3498db; }
.Eps8AfwecQcIRgcjFakD { background-color: #2ecc71; }
.v3Tne9pdMKVY_UfuBk8R { background-color: #f39c12; }

/* ============================================
   OHLC Hover Tooltip Positioning
   ============================================ */

.tqrmx8MfjjB6Y6TJ8sYW .ohlcTooltip {
  pointer-events: none;
  z-index: 200;
}

/* ============================================
   System Menu Dropdown Z-Index
   ============================================ */

.C0buiSvEwKHlhirU_gNr .menu,
.GPpbNxgAfiPpFd4AcAEc .menu {
  z-index: 1000;
}

/* ============================================
   High Contrast Mode
   ============================================ */

@media (prefers-contrast: high) {
  .uGMOoN4K9cKvAaBHYf0m {
    border: 2px solid currentColor;
  }
  
  .GPpbNxgAfiPpFd4AcAEc {
    border-right-width: 2px;
  }
  
  .POZJ4T2O94dSYG6dqBdd {
    border-width: 2px;
  }
  
  .POZJ4T2O94dSYG6dqBdd.AckVU2_HXzkjZE3I5VqY {
    border-width: 3px;
  }
  
  .XSgINE28Vb1D87LjgeTV {
    border-top-width: 2px;
  }
}

/* ============================================
   Reduced Motion
   ============================================ */

@media (prefers-reduced-motion: reduce) {
  .uGMOoN4K9cKvAaBHYf0m,
  .GPpbNxgAfiPpFd4AcAEc,
  .XSgINE28Vb1D87LjgeTV,
  .POZJ4T2O94dSYG6dqBdd,
  .YEH90U9ZziuWtWaAVN3s,
  .GPpbNxgAfiPpFd4AcAEc .unifiedDrawingToolbar {
    transition: none;
  }
}

/* ============================================
   Print Styles
   ============================================ */

@media print {
  .GPpbNxgAfiPpFd4AcAEc,
  .XSgINE28Vb1D87LjgeTV,
  .YEH90U9ZziuWtWaAVN3s,
  .C0buiSvEwKHlhirU_gNr .menu {
    display: none !important;
  }
  
  .uGMOoN4K9cKvAaBHYf0m {
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "charts"
      "footer";
  }
  
  .POZJ4T2O94dSYG6dqBdd {
    break-inside: avoid;
    border: 1px solid #000 !important;
  }
}

/* ============================================
   Dark Mode Variables (fallback)
   ============================================ */

@media (prefers-color-scheme: dark) {
  /* H0.8: this file is a CSS module, so the class would be hashed — hence
     \`:global(.vnsc-root)\`. The document-root selector never matches in the
     Shadow DOM, so these dark-mode variables resolved to "" in the bundle. */
  .vnsc-root {
    --vnsc-bg-primary: #131722;
    --vnsc-bg-secondary: #1e222d;
    --vnsc-bg-tertiary: #262b36;
    --vnsc-bg-hover: #232838;
    --vnsc-bg-input: #0d1117;
    --vnsc-border: #2a2e39;
    --vnsc-border-hover: #3a3e49;
    --vnsc-text-primary: #d1d4dc;
    --vnsc-text-secondary: #787b86;
    --vnsc-text-muted: #787b86;
    --vnsc-primary: #2962ff;
    --vnsc-primary-hover: #1a52e0;
    --vnsc-success: #0ecb81;
    --vnsc-danger-bg: #2a1a1a;
    --vnsc-danger-border: #442222;
    --vnsc-danger-text: #f87171;
    --vnsc-danger-hover: #3a2a2a;
    --vnsc-accent: #2962ff;
    --vnsc-accent-hover: #1a52e0;
    --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);
    --vnsc-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    --vnsc-font-mono: ui-monospace, SFMono-Regular, monospace;
  }
}

/* Mobile Touch Target Optimizations */
@media (max-width: 768px) {
  /* System menu items */
  .uGMOoN4K9cKvAaBHYf0m [role="menuitem"],
  .uGMOoN4K9cKvAaBHYf0m [role="option"] {
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }
  
  /* Footer tabs */
  .uGMOoN4K9cKvAaBHYf0m footer button {
    min-height: 44px;
    padding: 0 16px;
  }
  
  /* Search dropdown results */
  .uGMOoN4K9cKvAaBHYf0m .x_wYzZPbslh6RmQoQFrD li {
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/multicharts-layout.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;EAgBE;;AAEF;EACE,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B;;;YAGU;EACV,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;EACxC,uGAAuG;AACzG;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;4EAE4E;AAC5E;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,OAAO;EACP,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,kEAAkE;AACpE;;AAEA,+DAA+D;AAC/D;EACE,SAAS;EACT,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,0BAA0B;IAC1B,gCAAgC;IAChC;;;cAGU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS,EAAE,iBAAiB;IAC5B,OAAO;IACP,YAAY,EAAE,iBAAiB;IAC/B,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,yCAAyC;IACzC,mDAAmD;IACnD,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,OAAO;EACP,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,gDAAgD;AAChD,2CAAoC,0BAA0B,EAAE,uBAAuB,EAAE;AACzF,2CAAoC,8BAA8B,EAAE,uBAAuB,EAAE;AAC7F,2CAAoC,0BAA0B,EAAE,2BAA2B,EAAE;AAC7F,2CAAoC,8BAA8B,EAAE,2BAA2B,EAAE;AACjG,2CAAoC,qCAAqC,EAAE,uBAAuB,EAAE;AACpG,2CAAoC,0BAA0B,EAAE,kCAAkC,EAAE;AACpG,2CAAoC,qCAAqC,EAAE,2BAA2B,EAAE;AACxG,2CAAoC,qCAAqC,EAAE,kCAAkC,EAAE;;AAE/G,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAe,yBAAyB,EAAE;AAC1C,wBAAe,yBAAyB,EAAE;AAC1C,wBAAe,yBAAyB,EAAE;AAC1C,wBAAe,yBAAyB,EAAE;;AAE1C;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;;EAEE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;;;;;IAME,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,0BAA0B;IAC1B;;;cAGU;EACZ;;EAEA;IACE,mBAAmB;IACnB,iCAAiC;EACnC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;6EAE2E;EAC3E;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,6CAA6C;IAC7C,qFAAqF;IACrF,yDAAyD;EAC3D;AACF;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB;;IAEE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":["/**\r\n * Multicharts Layout Styles\r\n * CSS Grid layout for multicharts view with left sidebar toolbar\r\n * \r\n * Layout Structure:\r\n * ┌─────────────────────────────────────────────────────────────────────────────┐\r\n * │ Header (40px) - UnifiedHeader                                               │\r\n * ├──────────────────┬──────────────────────────────────────────────────────────┤\r\n * │                  │                                                          │\r\n * │ Drawing          │                                                          │\r\n * │ Toolbar          │         Charts Grid (MAXIMIZED AREA)                     │\r\n * │ (48px/280px)     │                                                          │\r\n * │                  │                                                          │\r\n * ├──────────────────┴──────────────────────────────────────────────────────────┤\r\n * │ Footer (32px) - MultiChartsFooter (auto-hide on mobile)                     │\r\n * └─────────────────────────────────────────────────────────────────────────────┘\r\n */\r\n\r\n.multichartsLayout {\r\n  display: grid;\r\n  grid-template-rows: 40px 1fr 32px;\r\n  grid-template-columns: 1fr;\r\n  grid-template-areas:\r\n    \"header\"\r\n    \"charts\"\r\n    \"footer\";\r\n  height: 100%;\r\n  height: 100dvh;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\r\n}\r\n\r\n/* Header - spans full width */\r\n.header {\r\n  grid-area: header;\r\n  z-index: 100;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.headerWorkspaceMode {\r\n  cursor: pointer;\r\n}\r\n\r\n/* Toolbar - absolute overlay */\r\n.toolbar {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 40px;\r\n  bottom: 32px;\r\n  width: 0px;\r\n  z-index: 500;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: visible;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Toolbar locked / docked mode (TASK-03) */\r\n.toolbarLocked .toolbar {\r\n  width: 44px;\r\n  pointer-events: auto;\r\n}\r\n\r\n.toolbarLocked .charts {\r\n  margin-left: 44px;\r\n}\r\n\r\n/* Bottom panel (Paper Trading / Strategy Tester / Pine Editor) is a grid\r\n   sibling of .charts (implicit row above the footer), so it needs the same\r\n   docked-rail clearance — otherwise the 44px rail overlaps its left edge. */\r\n.toolbarLocked [data-vnsc-bottom-panel=\"host\"] {\r\n  margin-left: 44px;\r\n}\r\n\r\n/* Charts area - maximized */\r\n.charts {\r\n  grid-area: charts;\r\n  z-index: 10;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* S1 (F8 full-height, mirror single): body-row chứa mainCol (charts +\r\n   panel) và dock. Overlay neo theo body (full content height như toolbar);\r\n   pinned in-flow đẩy cả col (grid + panel co như singlechart). */\r\n.workspaceBody {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.workspaceMainCol {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n}\r\n\r\n/* .charts là con flex của mainCol (giữ position/overflow cho replay overlay). */\r\n.workspaceBody .charts {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n/* Footer - spans full width */\r\n.footer {\r\n  grid-area: footer;\r\n  z-index: 100;\r\n  flex-shrink: 0;\r\n  transition: height 0.2s ease, opacity 0.2s ease, padding 0.2s ease;\r\n}\r\n\r\n/* Footer hidden state (auto-hide on mobile or chart focused) */\r\n.footer.hidden {\r\n  height: 0;\r\n  padding: 0 16px;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  border-top: none;\r\n}\r\n\r\n/* ============================================\r\n   Responsive Breakpoints\r\n   ============================================ */\r\n\r\n/* Desktop & Tablet toolbar visibility */\r\n@media (min-width: 769px) {\r\n  .toolbar {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n/* Mobile (<768px) - Toolbar hidden, shown via FAB */\r\n@media (max-width: 768px) {\r\n  .multichartsLayout {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 40px 1fr 0px;\r\n    grid-template-areas:\r\n      \"header\"\r\n      \"charts\"\r\n      \"footer\";\r\n  }\r\n  \r\n  .toolbar {\r\n    display: none;\r\n  }\r\n  \r\n  .toolbar.mobileVisible {\r\n    display: flex;\r\n    position: fixed;\r\n    top: 40px; /* Below header */\r\n    left: 0;\r\n    bottom: 32px; /* Above footer */\r\n    width: 280px;\r\n    max-width: 85vw;\r\n    height: auto;\r\n    max-height: calc(100vh - 72px);\r\n    z-index: 1000;\r\n    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);\r\n    border-right: 1px solid var(--vnsc-border, #2a2e39);\r\n    min-width: 280px;\r\n    max-width: 280px;\r\n    width: 280px;\r\n  }\r\n  \r\n  .footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 0px;\r\n    min-height: 0px;\r\n    padding: 0;\r\n    border-top: none;\r\n    overflow: visible;\r\n    pointer-events: none;\r\n    background: transparent;\r\n    z-index: 100;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   Toolbar Internal Layout\r\n   ============================================ */\r\n\r\n.toolbar :global(.unifiedDrawingToolbar) {\r\n  height: 100%;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Ensure toolbar content scrolls when expanded */\r\n.toolbar.expanded :global(.unifiedDrawingToolbar) {\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Collapsed toolbar - only show icons */\r\n.toolbar.collapsed :global(.toolbarContent) {\r\n  display: none;\r\n}\r\n\r\n.toolbar.collapsed :global(.toolbarHeader) {\r\n  padding: 8px;\r\n  justify-content: center;\r\n}\r\n\r\n.toolbar.collapsed :global(.toolbarHeader .toolbarTitle),\r\n.toolbar.collapsed :global(.toolbarHeader .lockToggle),\r\n.toolbar.collapsed :global(.toolbarHeader .collapseToggle) {\r\n  display: none;\r\n}\r\n\r\n.toolbar.collapsed :global(.toolbarHeader .expandToggle) {\r\n  display: flex;\r\n}\r\n\r\n/* ============================================\r\n   Charts Grid Container\r\n   ============================================ */\r\n\r\n.chartsContainer {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* Grid container for chart slots */\r\n.gridContainer {\r\n  flex: 1;\r\n  display: grid;\r\n  gap: 8px;\r\n  padding: 8px;\r\n  min-height: 0;\r\n  overflow: auto;\r\n}\r\n\r\n/* Grid layout variations based on chart count */\r\n.gridContainer[data-layout=\"1x1\"] { grid-template-columns: 1fr; grid-template-rows: 1fr; }\r\n.gridContainer[data-layout=\"1x2\"] { grid-template-columns: 1fr 1fr; grid-template-rows: 1fr; }\r\n.gridContainer[data-layout=\"2x1\"] { grid-template-columns: 1fr; grid-template-rows: 1fr 1fr; }\r\n.gridContainer[data-layout=\"2x2\"] { grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; }\r\n.gridContainer[data-layout=\"1x4\"] { grid-template-columns: repeat(4, 1fr); grid-template-rows: 1fr; }\r\n.gridContainer[data-layout=\"4x1\"] { grid-template-columns: 1fr; grid-template-rows: repeat(4, 1fr); }\r\n.gridContainer[data-layout=\"2x4\"] { grid-template-columns: repeat(4, 1fr); grid-template-rows: 1fr 1fr; }\r\n.gridContainer[data-layout=\"3x3\"] { grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(3, 1fr); }\r\n\r\n/* Chart slot */\r\n.chartSlot {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  border: 1px solid var(--vnsc-border, #2a2e39);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  position: relative;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.chartSlot:hover {\r\n  border-color: var(--vnsc-border-hover, #3a3e49);\r\n}\r\n\r\n.chartSlot.active {\r\n  border: 1px solid var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.chartSlot.empty {\r\n  border: 2px dashed var(--vnsc-border, #2a2e39);\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--vnsc-bg-secondary, #1e222d);\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.chartSlot.empty:hover {\r\n  background: var(--vnsc-bg-tertiary, #262b36);\r\n  border-color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.chartSlot.empty:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.chartSlot.empty span {\r\n  color: var(--vnsc-text-muted, #787b86);\r\n  font-size: 14px;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Slot header with symbol badge */\r\n.slotHeader {\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 8px;\r\n  right: 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  z-index: 10;\r\n  pointer-events: none;\r\n}\r\n\r\n.slotHeader > * {\r\n  pointer-events: auto;\r\n}\r\n\r\n.symbolBadge {\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  color: white;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.groupBadge {\r\n  color: white;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.groupBadgeA { background-color: #e74c3c; }\r\n.groupBadgeB { background-color: #3498db; }\r\n.groupBadgeC { background-color: #2ecc71; }\r\n.groupBadgeD { background-color: #f39c12; }\r\n\r\n/* ============================================\r\n   OHLC Hover Tooltip Positioning\r\n   ============================================ */\r\n\r\n.charts :global(.ohlcTooltip) {\r\n  pointer-events: none;\r\n  z-index: 200;\r\n}\r\n\r\n/* ============================================\r\n   System Menu Dropdown Z-Index\r\n   ============================================ */\r\n\r\n.header :global(.menu),\r\n.toolbar :global(.menu) {\r\n  z-index: 1000;\r\n}\r\n\r\n/* ============================================\r\n   High Contrast Mode\r\n   ============================================ */\r\n\r\n@media (prefers-contrast: high) {\r\n  .multichartsLayout {\r\n    border: 2px solid currentColor;\r\n  }\r\n  \r\n  .toolbar {\r\n    border-right-width: 2px;\r\n  }\r\n  \r\n  .chartSlot {\r\n    border-width: 2px;\r\n  }\r\n  \r\n  .chartSlot.active {\r\n    border-width: 3px;\r\n  }\r\n  \r\n  .footer {\r\n    border-top-width: 2px;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   Reduced Motion\r\n   ============================================ */\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .multichartsLayout,\r\n  .toolbar,\r\n  .footer,\r\n  .chartSlot,\r\n  .slotHeader,\r\n  .toolbar :global(.unifiedDrawingToolbar) {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   Print Styles\r\n   ============================================ */\r\n\r\n@media print {\r\n  .toolbar,\r\n  .footer,\r\n  .slotHeader,\r\n  .header :global(.menu) {\r\n    display: none !important;\r\n  }\r\n  \r\n  .multichartsLayout {\r\n    grid-template-rows: auto 1fr auto;\r\n    grid-template-columns: 1fr;\r\n    grid-template-areas:\r\n      \"header\"\r\n      \"charts\"\r\n      \"footer\";\r\n  }\r\n  \r\n  .chartSlot {\r\n    break-inside: avoid;\r\n    border: 1px solid #000 !important;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   Dark Mode Variables (fallback)\r\n   ============================================ */\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  /* H0.8: this file is a CSS module, so the class would be hashed — hence\r\n     `:global(.vnsc-root)`. The document-root selector never matches in the\r\n     Shadow DOM, so these dark-mode variables resolved to \"\" in the bundle. */\r\n  :global(.vnsc-root) {\r\n    --vnsc-bg-primary: #131722;\r\n    --vnsc-bg-secondary: #1e222d;\r\n    --vnsc-bg-tertiary: #262b36;\r\n    --vnsc-bg-hover: #232838;\r\n    --vnsc-bg-input: #0d1117;\r\n    --vnsc-border: #2a2e39;\r\n    --vnsc-border-hover: #3a3e49;\r\n    --vnsc-text-primary: #d1d4dc;\r\n    --vnsc-text-secondary: #787b86;\r\n    --vnsc-text-muted: #787b86;\r\n    --vnsc-primary: #2962ff;\r\n    --vnsc-primary-hover: #1a52e0;\r\n    --vnsc-success: #0ecb81;\r\n    --vnsc-danger-bg: #2a1a1a;\r\n    --vnsc-danger-border: #442222;\r\n    --vnsc-danger-text: #f87171;\r\n    --vnsc-danger-hover: #3a2a2a;\r\n    --vnsc-accent: #2962ff;\r\n    --vnsc-accent-hover: #1a52e0;\r\n    --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);\r\n    --vnsc-font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n    --vnsc-font-mono: ui-monospace, SFMono-Regular, monospace;\r\n  }\r\n}\r\n\r\n/* Mobile Touch Target Optimizations */\r\n@media (max-width: 768px) {\r\n  /* System menu items */\r\n  .multichartsLayout [role=\"menuitem\"],\r\n  .multichartsLayout [role=\"option\"] {\r\n    min-height: 44px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 16px;\r\n  }\r\n  \r\n  /* Footer tabs */\r\n  .multichartsLayout footer button {\r\n    min-height: 44px;\r\n    padding: 0 16px;\r\n  }\r\n  \r\n  /* Search dropdown results */\r\n  .multichartsLayout .vnsc-symbol-search-dropdown-container li {\r\n    min-height: 44px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multichartsLayout": `uGMOoN4K9cKvAaBHYf0m`,
	"header": `C0buiSvEwKHlhirU_gNr`,
	"headerWorkspaceMode": `WkTc7VA7ItuB3zne23eB`,
	"toolbar": `GPpbNxgAfiPpFd4AcAEc`,
	"toolbarLocked": `TF7yQ34YrHNDvxbHBAFn`,
	"charts": `tqrmx8MfjjB6Y6TJ8sYW`,
	"workspaceBody": `CKcUXpPOtLqbuZPE0I_K`,
	"workspaceMainCol": `laVS05mDRGY_aUq2tlef`,
	"footer": `XSgINE28Vb1D87LjgeTV`,
	"hidden": `VckaXpRpayS5qjEk2rZm`,
	"mobileVisible": `TakSWYyihw5fMquxNm3T`,
	"expanded": `K1AtK5MPnEQ9sCxepkqn`,
	"collapsed": `HPgd5MKkETlVS6EC5mnI`,
	"chartsContainer": `plua5kAY_Zfbv3qCsDSc`,
	"gridContainer": `clspduxZXiEWMo8tjf0M`,
	"chartSlot": `POZJ4T2O94dSYG6dqBdd`,
	"active": `AckVU2_HXzkjZE3I5VqY`,
	"empty": `igM6sFFtNiCifeaRtd3m`,
	"slotHeader": `YEH90U9ZziuWtWaAVN3s`,
	"symbolBadge": `dbJ6pgUgimItoimqcFZo`,
	"groupBadge": `aDmMClrETuqYtL4RTtQQ`,
	"groupBadgeA": `MtJjnDUkDN0kEmkyFPDP`,
	"groupBadgeB": `Pbisyyb7MrMe40NuNA6A`,
	"groupBadgeC": `Eps8AfwecQcIRgcjFakD`,
	"groupBadgeD": `v3Tne9pdMKVY_UfuBk8R`,
	"vnsc-symbol-search-dropdown-container": `x_wYzZPbslh6RmQoQFrD`
};
export default ___CSS_LOADER_EXPORT___;
